export default __webpack_public_path__ + "static/media/sleepy.8c4c166e.png";